import { pxToRem } from '../../../../utils';
export var popupContentVariables = function popupContentVariables(siteVars) {
  return {
    borderColor: siteVars.colorScheme.default.borderTransparent,
    borderRadius: siteVars.borderRadiusMedium,
    borderSize: '1px',
    backgroundColor: siteVars.colorScheme.default.background,
    color: siteVars.colorScheme.default.foreground,
    boxShadow: siteVars.shadow16,
    padding: "" + pxToRem(16),
    pointerGap: pxToRem(5),
    pointerMargin: pxToRem(10),
    pointerHeight: pxToRem(7),
    pointerWidth: pxToRem(14),
    zIndex: siteVars.zIndexes.overlay
  };
};